module.exports = __webpack_public_path__ + "static/media/8 box ba atish.6b684bed.svg";